import React from "react";
import { useNavigate } from "react-router-dom";
const InvoiceCard = (props) => {
  const navigate = useNavigate();
  // console.log("InvoiceCard", props)
  return (
    <div className="w-full border rounded bg-[#f8eede] border-[#b3853e]">
      <div className="text-center text-xs ">
        <p className="font-bold">ประเภท</p>
        <p className="font-bold">{props.data.lotteryName}</p>
      </div>
      <div className="grid grid-cols-2 p-3 place-content-around">
        <div className="text-xs ">
          <p>หมายเลขออเดอร์</p>
          <p className="font-bold">{props.data.refCode}</p>
        </div>
        <div className="text-xs text-end">
          <p>งวดประจำวัน</p>
          <p className="font-bold">{new Date(props.data.closeSaleDatetime).toLocaleDateString("th-TH")}</p>
        </div>

        <div className="text-xs my-2">
          {/* <p>จำนวนใบ</p>
          <p className="font-bold">2 ใบ</p> */}
        </div>
        <div className="text-xs text-end my-2">
          <p>จำนวนเงิน</p>
          <p className="font-bold">{props.data.totalBetAmount} บาท</p>
        </div>

        <div className="text-xs ">
          <p>วัน-เวลา ที่สั่งซื้อ</p>
          <p className="font-bold">{new Date(props.data.invoiceDatetime).toLocaleDateString("th-TH")}</p>

        </div>
        {props.data.isCancel == "yes" ? (
          <button className="bg-[#b3853e] text-[#f8eede] text-xs rounded-full my-1 font-bold">คืนโพยแล้ว</button>
        ) :
          <button
            className="bg-[#b3853e] text-[#f8eede] text-xs rounded-full my-1 font-bold"

            onClick={() => navigate(
              '/invoiceinfomation',
              {
                state: {
                  cancelData: props.data.cancelData,
                  closeSaleDatetime: props.data.closeSaleDatetime,
                  currency: props.data.currency,
                  invoiceDatetime: props.data.invoiceDatetime,
                  isCancel: props.data.isCancel,
                  isWin: props.data.isWin,
                  lotteryId: props.data.lotteryId,
                  lotteryName: props.data.lotteryName,
                  refCode: props.data.refCode,
                  totalBetAmount: props.data.totalBetAmount,
                  totalPayAmount: props.data.totalPayAmount,
                  totalWinLoseAmount: props.data.totalWinLoseAmount,
                  _id: props.data._id,
                  remark: props.data.remark
                }
              })}
          >
            รายละเอียด
          </button>
        }
        <p className="font-bold text-sm mt-0.5">บันทึกโพย: {props.data.remark}</p>

      </div>

      <div className="text-center text-xs ">
        <button
          className="text-[#b3853e] text-xs rounded-full my-1 font-bold"

        >
          <p
            className={`${props.data.isCancel == "yes"
              ? "bg-gray-500"
              : props.data.isWin == "yes"
                ? "bg-green-500"
                : props.data.isWin == "no"
                  ? "bg-red-500"
                  : "bg-orange-400"
              } w-24 text-sm h-auto rounded-full text-center text-white px-1 py-1 mr-1`}
          >
            {props.data.isCancel == "yes"
              ? "คืนโพย"
              : props.data.isWin == "yes"
                ? "ถูกรางวัล"
                : props.data.isWin == "no"
                  ? "ไม่ถูกรางวัล"
                  : "รอผล"}
          </p>
        </button>
      </div>

    </div >
  );
};

export default InvoiceCard;
